//// prod server
export const API = "https://paladmin.oneschoolsuite.com/pal/";
export const FLASK_API = "https://flaskapi.oneschoolsuite.com/";


// Production Server
export const JAVA_MASTER_API = "https://pal-full-api.oneschoolsuite.com/pal-java-api/v1/"
export const JAVA_AUTH_API = "https://pal-full-api.oneschoolsuite.com/api/v1/";
export const JAVA_DASHBOARD_API = "https://pal-full-api.oneschoolsuite.com/java-api/v1/";


// Local Server
// export const JAVA_MASTER_API = "https://pal-full-api.oneschoolsuite.com/pal-java-api/v1/";
// export const JAVA_AUTH_API = "http://192.168.1.38:9999/api/v1/";
// export const JAVA_DASHBOARD_API = "http://192.168.1.38:9999/java-api/v1/";
